import axios from 'axios'
import { avivaUserService } from 'src/api/server'

import { getErrorMessage } from '@core/helpers/errors'
import { capitalizeAll } from '@core/helpers/text'
import { type Catalog } from '@core/types/components'
import {
  type RegisterResData,
  type UserInfoByDocumentResponse
} from '@core/types/server/registerRes'
import { type AvivaServerResponse } from '@core/types/server/res'

import { type RENIACResponse, type RENIACUserData } from './types'

export const getUserInfoFromRENIEC = async (dni: string): Promise<RENIACUserData> => {
  const { data } = await avivaUserService.get<RENIACResponse>('/patient/getFromRENIEC', {
    params: {
      documentNumber: dni
    }
  })
  if (!data.valid || !data.data) {
    throw new Error('La identificación ingresada no es correcta')
  }

  const { nombres, apellidoMaterno, apellidoPaterno } = data.data

  const result: RENIACUserData = {
    ...data.data,
    nombres: capitalizeAll(nombres),
    apellidoMaterno: capitalizeAll(apellidoMaterno),
    apellidoPaterno: capitalizeAll(apellidoPaterno)
  }

  return result
}

export const verifyIfUserExists = async (
  centerId: number,
  documentType: number,
  documentNumber: string
): Promise<boolean | null> => {
  try {
    const { data } = await avivaUserService.get<UserInfoByDocumentResponse>(
      '/patient/getByDocument',
      {
        params: {
          centerId,
          documentType,
          documentNumber
        }
      }
    )
    if (!data.result.valid) throw new Error()

    return true
  } catch (error: any) {
    const errorMessage = getErrorMessage(error)
    if (errorMessage === 'No existe paciente con el documento ingresado') return false

    return null
  }
}

export interface RegisterBody {
  centerId: number
  email: string
  emailConfirm: string
  password: string
  name: string
  surname1: string
  surname2: string
  birthdateAsString: string
  gender: Catalog
  documentType: Catalog
  username: string
  documentNumber: string
  termsAccepted: boolean
  phone: string
}

export const registerUser = async (body: RegisterBody): Promise<RegisterResData> => {
  try {
    const { data } = await avivaUserService.post<AvivaServerResponse<RegisterResData>>(
      '/register/user',
      body
    )
    // console.log({ registerData: data })
    if (!data.valid || !data.data) {
      throw new Error('Error registrando el usuario')
    }

    return data.data
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data.result.message as string)
    } else {
      throw new Error(error.message as string)
    }
  }
}
